import script from "./QModalRfidCreate.vue?vue&type=script&setup=true&lang=js"
export * from "./QModalRfidCreate.vue?vue&type=script&setup=true&lang=js"

import "./QModalRfidCreate.vue?vue&type=style&index=0&id=1d06a491&scoped=true&lang=scss"

import exportComponent from "/home/signal-frontend-demo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d06a491"]])

export default __exports__